import type { NotarizationFile, NotarizationStatsSummary } from '@trace/shared/types';

export const mockNotarizationFiles: NotarizationFile[] = [
  {
    id: 21001,
    notaryNumber: '(2026)黑哈五证字第8821号',
    notaryOffice: '黑龙江省五常市公证处',
    notaryTitle: '2026年度五常有机稻米全生命周期溯源数据保全与赋码公证书',
    notaryType: 'data_preservation',
    notaryDate: '2026-08-15',
    notaryOfficer: '刘振华 / 李立公证员',
    fileUrl: 'ledgers/notarization/(2026)黑哈五证字第8821号_数据保全公证书.pdf',
    fileName: '五常市公证处_有机水稻全链条数据保全公证书.pdf',
    fileSize: 6480000,
    sha256Hash: 'e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855',
    enterpriseId: 'ent_01',
    enterpriseName: '五常市金穗生态大米加工有限公司',
    status: 'active',
    remarks: '针对核心示范区1号、2号稻田种植、收割、MES初碾脱壳与分装全链数据进行司法保全，公证书合法有效。',
    createdAt: '2026-08-15 10:00:00',
    updatedAt: '2026-08-15 10:00:00',
  },
  {
    id: 21002,
    notaryNumber: '(2026)黑齐嫩证字第3042号',
    notaryOffice: '黑龙江省嫩江市公证处',
    notaryTitle: '嫩江天然高寒有机富硒黑米原产地溯源赋码专项目录公证书',
    notaryType: 'trace_code_batch',
    notaryDate: '2026-08-20',
    notaryOfficer: '王明远 公证员',
    fileUrl: 'ledgers/notarization/(2026)黑齐嫩证字第3042号_富硒黑米公证书.pdf',
    fileName: '嫩江市公证处_富硒黑米赋码专项公证书.pdf',
    fileSize: 5230000,
    sha256Hash: '9f86d081884c7d659a2feaa0c55ad015a3bf4f1b2b0b822cd15d6c15b0f00a08',
    enterpriseId: 'ent_02',
    enterpriseName: '齐齐哈尔嫩江绿色农业加工厂',
    status: 'active',
    remarks: '经嫩江公证处现场监督抽样，原粮508项无农残，MA一物一码赋码批次真实有效。',
    createdAt: '2026-08-20 14:30:00',
    updatedAt: '2026-08-20 14:30:00',
  },
  {
    id: 21003,
    notaryNumber: '(2026)浙杭之证字第1190号',
    notaryOffice: '浙江省杭州市之江公证处',
    notaryTitle: '秋田满满母婴辅食级有机胚芽米定制批次生产过程证据保全公证书',
    notaryType: 'data_preservation',
    notaryDate: '2026-08-28',
    notaryOfficer: '陈晓冬 公证员',
    fileUrl: 'ledgers/notarization/(2026)浙杭之证字第1190号_秋田满满公证书.pdf',
    fileName: '杭州之江公证处_秋田满满母婴定制公证书.pdf',
    fileSize: 7120000,
    sha256Hash: '5e884898da28047151d0e56f8dc6292773603d0d6aabbdd62a11ef721d1542d8',
    enterpriseId: 'ent_01',
    enterpriseName: '五常市金穗生态大米加工有限公司',
    status: 'active',
    remarks: '十万级洁净车间充氮分装全流程区块链及公证处联合存证。',
    createdAt: '2026-08-28 11:20:00',
    updatedAt: '2026-08-28 11:20:00',
  },
  {
    id: 21004,
    notaryNumber: '(2026)湘长星证字第0945号',
    notaryOffice: '湖南省长沙市星城公证处',
    notaryTitle: '英式Engnice低敏有机胚芽米原料进厂与出厂全项质检公证认证函',
    notaryType: 'enterprise_qualification',
    notaryDate: '2026-08-29',
    notaryOfficer: '周建国 公证员',
    fileUrl: 'ledgers/notarization/(2026)湘长星证字第0945号_英式公证书.pdf',
    fileName: '长沙星城公证处_英式低敏有机米公证认证书.pdf',
    fileSize: 4890000,
    sha256Hash: '4b227777d4dd1fc61c6f884f48641d02b4d121d3fd328cb08b5531fcacdabf8a',
    enterpriseId: 'ent_01',
    enterpriseName: '五常市金穗生态大米加工有限公司',
    status: 'active',
    remarks: '针对重金属与微生物指标符合母婴标准之公证文书。',
    createdAt: '2026-08-29 16:00:00',
    updatedAt: '2026-08-29 16:00:00',
  },
];

export const mockNotarizationStatsSummary: NotarizationStatsSummary = {
  totalCount: 4,
  activeCount: 4,
  dataPreservationCount: 2,
  monthlyNewCount: 4,
};
